import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import "./Navbar_1.css";
import "../../../UiComponents/Navbar.css";
import { useDispatch, useSelector } from "react-redux";
import { getDefaultSettings } from "../../../Redux/actions/defaultSettingsActions";
import { New_ScrollX2025, NotificationsIcon } from "../../../assets/icons/index";
import {
  deleteNotifications,
  getNotification,
  updateNotification,
} from "../../../Redux/actions/commonActtion";
import { DropdownForNotiFy } from "../../../Components";
import Setting from "../../Setting/Setting";
import { IoMdArrowRoundBack } from "react-icons/io";

const NOTIFICATION_PAGE_SIZE = 15;

export default function Navbar_1() {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const profileBtnRef = useRef(null);
  const notificationBtnRef = useRef(null);
  const project = useSelector((state) => state.project);
  const { isCard } = useSelector((state) => state.project);

  const notifications = useSelector(
    (state) => state.commonReducer.notifications,
  );
  const unreadCount = useSelector(
    (state) =>
      state.commonReducer.unreadCount ??
      state.commonReducer.notificationsWithReadStatus?.length ??
      0,
  );
  const notificationsHasMore = useSelector(
    (state) => state.commonReducer.notificationsHasMore,
  );
  const notificationsPage = useSelector(
    (state) => state.commonReducer.notificationsPage || 1,
  );
  const notificationsLoading = useSelector(
    (state) => state.commonReducer.notificationsLoading,
  );

  useEffect(() => {
    fetchProjectSettings();
    // Badge only — avoid downloading the full notification list on mount
    dispatch(getNotification({ page_no: 1, limit: 0 }));
  }, []);

  const fetchProjectSettings = () => {
    dispatch(getDefaultSettings());
  };

  const getAllNotification = async () => {
    if (isOptionsVisible) {
      setIsOptionsVisible(false);
      return;
    }

    setIsSettingOpen(false);

    if (unreadCount > 0) {
      await dispatch(updateNotification());
    }

    setIsOptionsVisible(true);
    await dispatch(
      getNotification({
        page_no: 1,
        limit: NOTIFICATION_PAGE_SIZE,
        append: false,
      }),
    );
  };

  const fetchMoreData = useCallback(() => {
    if (!notificationsHasMore || notificationsLoading) return;
    dispatch(
      getNotification({
        page_no: notificationsPage + 1,
        limit: NOTIFICATION_PAGE_SIZE,
        append: true,
      }),
    );
  }, [
    dispatch,
    notificationsHasMore,
    notificationsLoading,
    notificationsPage,
  ]);

  const handleDeleteNotification = async (id) => {
    dispatch(deleteNotifications({ notification_id: id }));
  };

  const getUserInitials = () => {
    const firstName = userInfo?.firstName?.trim() || "";
    if (firstName) return firstName.charAt(0).toUpperCase();
    return "U";
  };

  const getBackgroundColor = () => "#7c5cff26";

  return (
    <>
      <nav
        id="navbar_1"
        className="w-full h-full Pro_navbarDash flex flex-wrap justify-between items-center  text-slate-200 focus:text-sly-700 drop-shadow-2xl"
      >
        <div className="w-full h-full flex flex-wrap items-center justify-between ">
          <div className="flex items-center gap-3 min-w-0">
            <Link
              className="arrowIcon flex items-center opacity-30 hover:opacity-100"
              to="/dashboard"
            >
              <IoMdArrowRoundBack size={20} />
            </Link>

            <div className="h-[17px] w-[1px] bg-[#ffffff1a]" />

            <div className="flex items-center gap-2.5 hedertext min-w-0">
              <span className="w-2 h-2 rounded-full bg-[#7c5cff] shadow-[0_0_8px_rgba(124,92,255,.8)] circleIcon" />
              <span className="hedertext font-semibold text-[14px]">
                Dashboard
              </span>
              <span className="hedertext">/</span>
              <span className="text-[#625e83] font-normal">
                {isCard ? "Card" : "Scroll"}
              </span>
            </div>
          </div>

          <div
            className="w-[50%] flex justify-center items-center"
            style={{ paddingLeft: "10rem" }}
          >
            <h1 className="font-body text-[15px] text-white">
              {project?.title?.toUpperCase()}
            </h1>
          </div>

          <div className="flex justify-end w-[30%]">
            <div className="flex items-center">
              <div className="flex mx-3 px-1 notification">
                <button
                  ref={notificationBtnRef}
                  type="button"
                  onClick={getAllNotification}
                  aria-expanded={isOptionsVisible}
                  aria-haspopup="true"
                  aria-label="Notifications"
                >
                  <img
                    className="pro_navabr_Notifications opacity-75"
                    src={NotificationsIcon}
                    alt=""
                  />
                </button>
                {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
              </div>

              <div className="flex m-auto">
                <button
                  ref={profileBtnRef}
                  type="button"
                  className="w-[35px] h-[35px] flex justify-center items-center border-[1px] border-[#7c5cff4d] hover:bg-[#7c5cff40] rounded-full transition-colors"
                  onClick={() => {
                    setIsOptionsVisible(false);
                    setIsSettingOpen((open) => !open);
                  }}
                  style={{ backgroundColor: getBackgroundColor() }}
                  aria-expanded={isSettingOpen}
                  aria-haspopup="true"
                >
                  <div className="flex justify-center items-center text-[#c4b2ff] text-xl font-body w-[35px] h-[35px] rounded-full">
                    <span className="font-body text-[#c4b2ff] text-lg text-center">
                      {getUserInitials()}
                    </span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <Setting
        isSettingOpen={isSettingOpen}
        setIsSettingOpen={setIsSettingOpen}
        anchorRef={profileBtnRef}
      />

      <DropdownForNotiFy
        isOptionsVisible={isOptionsVisible}
        setIsOptionsVisible={setIsOptionsVisible}
        options={notifications}
        handleDeleteNotification={handleDeleteNotification}
        anchorRef={notificationBtnRef}
        fetchMoreData={fetchMoreData}
        hasMore={notificationsHasMore}
        isLoadingMore={notificationsLoading}
      />
    </>
  );
}
